import clsx from 'clsx'
import React from 'react'
import { Pressable, View, type PressableProps, type ViewProps } from 'react-native'

import { useCardContext } from './card-context'

type TCardBodyProps = ViewProps & Pick<PressableProps, 'onPress'> & { ref?: React.Ref<View> }

export const CardBody = ({ ref, className, children, ...otherProps }: TCardBodyProps) => {
  const { slots, classNames } = useCardContext()

  const Component = otherProps.onPress ? Pressable : View

  return (
    <Component ref={ref} className={slots.body?.({ class: clsx(classNames?.body, className) })} {...otherProps}>
      {children}
    </Component>
  )
}

CardBody.displayName = 'CardBody'
